/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcutils.sv.factory:SvHelper
   *
   * @description
   *
   */
  angular
    .module('vcutils.sv')
    .factory('SvHelper', SvHelper);
  
  
  SvHelper.$inject = ['Sv', '$uibModal', '$log', 'Rlog'];
  
  function SvHelper(Sv, $uibModal, $log, Rlog) {
    let SvHelperBase = {};
    
    SvHelperBase.editSv = editSv;
    SvHelperBase.addSv = addSv;
  
  
    function addSv(success, error) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><svform sv="svaCtrl.sv" parentsave="svaCtrl.childsave(sv)" oncancel="svaCtrl.cancel()"></svnew></div>',
        controllerAs: 'svaCtrl',
        controller: ['sv', function () {
          let vm = this;
          vm.sv = {};
          
          vm.childsave = childsave;
          vm.cancel = cancel;
          
          function childsave(sv) {
            Sv.$create(sv).$then(function (newsv) {
              vm.created = true;
              success(newsv);
              dialog.close();
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed @ sv-helper.addSv: ', err);
              Rlog.error('vcutils.sv', 'sv-helper.addSv', 'Creation of new SV failed: ', {error: err, sv: sv});
              error(err);
              dialog.close();
            });
          }
          
          function cancel() {
            dialog.close();
          }
          
        }],
        resolve: {
          sv: function () {
            return {};
          }
        },
        size: 'lg'
      });
    }
    
    
    function editSv(lsv) {
      let dialog = $uibModal.open({
        template: '<div class="modalspacer"><svform sv="sveCtrl.sv" parentsave="sveCtrl.childsave(sv)" oncancel="sveCtrl.cancel()"></svform></div>',
        controllerAs: 'sveCtrl',
        controller: ['sv', function (ssv) {
          let vm = this;
          vm.sv = ssv;
          vm.childsave = childsave;
          vm.cancel = cancel;
  
  
          function childsave(sv) {
            // vm.sv = angular.copy(sv);
            // the abouve code threw an restmod error, despite actually saving
            // the below variant does not raise an error
            for (let key in sv) {
              if (sv.hasOwnProperty(key)) {
                vm.sv[key] = sv[key];
              }
            }

            if (vm.sv.$hasPendingActions()) {
              vm.sv.$cancel();
              vm.sv.$save();
              cancel();
            }
            else {
              vm.sv.$save();
              dialog.close();
            }
          }
          
  
          function cancel() {
            dialog.close();
          }
          
          
        }],
        resolve: {
          sv: function () {
            return lsv;
          }
        },
        size: 'lg'
      });
      return dialog;
    }
    
    return SvHelperBase;
  }
}());
